import { WishListComponent } from '../../components/WishListComponent/WishListComponent'
import styles from './styles.module.css'
import { auth } from '../../firebase.config'
import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { useDataLoader } from '../../components/hooks/useDataLoader'
import { getWishPublicId } from '../../constans/functions/shareLinkServices'
import { useState } from 'react'
import { ShareModal } from '../../components/ShareModal/ShareModal'


export const WishListPage = () => {

  const wishlistCountries = useSelector((state) => state.wishList.wishlist);
  const isLoading = useSelector((state) => state.wishList.isLoading);
  const [isCopying, setIsCopying] = useState(false);
  const [modalShareOpen, setModalShareOpen] = useState(false);
  const [shareLink, setShareLink] = useState();


  const generateWishlistShareLink = async () => {
      try {
        setIsCopying(true);
        if (!auth.currentUser) {
          alert('Please sign in to share your list');
          return;
        }
  
        const publicId = await getWishPublicId(auth.currentUser.uid)
  
        if (publicId) {
          const baseUrl = window.location.origin;
          const shareLink = `${baseUrl}/shared/wishlist/${publicId}`;
          setShareLink(shareLink);
          try {
            await navigator.clipboard.writeText(shareLink);
          } catch (err) {
            console.error('Failed to copy: ', err);
          }
          setModalShareOpen(true);
        } else {
          alert('Error generating share link');
        }
  
      } catch (err) {
        console.error('Error generating share link:', err);
        alert('Error generating share link');
      } finally {
        setIsCopying(false);
      }
    };
   
  useDataLoader();

  const userName = () => {
    if (auth.currentUser && auth.currentUser.displayName) {
      return auth.currentUser.displayName
    } else {
      return 'Guest'
    }
  }

    if (isLoading) {
      return (
        <div>
          <h1 className={styles.h1}>Loading your wishlist...</h1>
        </div>
      );
    }

  const greetings = () => {
    
    if (isLoading) {
      return (
        <div>
          <h1 className={styles.h1}>Loading your wishlist...</h1>
        </div>
      );
    }

    if (wishlistCountries.length === 0) {
      return (
        <div>
          <h1 className={styles.h1}>
            What's on your travel wishlist? 🌴
          </h1>
            <h2 className={styles.h2}>
             Add countries you dream of visiting and build your perfect bucket list
            </h2>
               <div className={styles.links_container}>
                <NavLink className={`${styles.link_to_countries} ${styles.link_to_flags}`} to='/allflags'>Countries <br /> by flags</NavLink>
                <NavLink className={`${styles.link_to_countries} ${styles.link_to_names}`} to='/allnames'>Countries <br /> by names</NavLink>
              </div>
        </div>
      )
    } else if (wishlistCountries.length === 1) {
      return (
        <div>
          <h1 className={styles.h1}>{ 
            `${wishlistCountries.length} country to explore, ${userName()}!`}</h1>
          <h2 className={styles.h2}>
              Your wishlist is calling!</h2>
          <div className={styles.button_container}>
            <button 
              className={styles.share_button}
              onClick={generateWishlistShareLink}
              disabled={isCopying}>
              <div className={styles.plane_icon}>
                  <svg width="64" height="64" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22 2L11 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M22 2L15 22L11 13L2 9L22 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
                  </svg>
              </div>
              Share Your Dreams
              <div className={styles.arrow_icon}>→</div>
            </button>
          </div>
        </div>
      )
    } else {
      return (
      <div>
          <h1 className={styles.h1}>{ 
            `${wishlistCountries.length} countries to explore, ${userName()}!`}</h1>
          <h2 className={styles.h2}>
              Your wishlist is calling!</h2>
          <div className={styles.button_container}>
            <button 
              className={styles.share_button}
              onClick={generateWishlistShareLink}
              disabled={isCopying}>
              <div className={styles.plane_icon}>
                <svg width="64" height="64" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22 2L11 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M22 2L15 22L11 13L2 9L22 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
                </svg>
              </div>
              Share Your Dreams
              <div className={styles.arrow_icon}>→</div>
            </button>
          </div>
        </div>
      )
    }
  }

  return (
    <div className={styles.root}>
    <div className={styles.greetings}>{greetings()}</div>
      <WishListComponent />

      <ShareModal
        isOpen={modalShareOpen} 
        onClose={() => {setModalShareOpen(false)}}
        listName={'wishlist'}
        shareLink={shareLink}>
      </ShareModal>
      <footer className={styles.footer}>
        <div className={styles.footer_content}> 
          <h1 className={styles.seo_text_h1}>This is your wishlist of countries!</h1>
          <h2 className={styles.seo_text}>
            Share it, post it, follow it.
            <br /> 
            <br />Add countries you have already visited to your "visited" list by clicking the "add" button, or remove them from here if you've lost interest in a country or just changed your mind.
            <br />
            <br />Get more countries for your travel plans from the <NavLink className={styles.names_link} to={'/allflags'}>flags page</NavLink> or get a random country in your <NavLink className={styles.names_link} to={'/profile'}>profile</NavLink>.
          </h2>
        </div>
      </footer>
    </div>
  )
}
